/* Collections/search redesign: chip row scroll arrows (desktop) + edge fades. */
(function () {
  if (window.__tmcChips) return;
  window.__tmcChips = true;
  function init(wrap) {
    var list = wrap.querySelector('.tmc-chips');
    var prev = wrap.querySelector('[data-tmc-prev]');
    var next = wrap.querySelector('[data-tmc-next]');
    if (!list) return;
    function update() {
      var max = list.scrollWidth - list.clientWidth;
      var x = list.scrollLeft;
      wrap.classList.toggle('is-start', x <= 2);
      wrap.classList.toggle('is-end', x >= max - 2);
      wrap.classList.toggle('is-scrollable', max > 2);
    }
    function go(dir) { list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Bring the current chip into view.
    var cur = list.querySelector('[aria-current="page"]');
    if (cur) {
      var lr = list.getBoundingClientRect(), cr = cur.getBoundingClientRect();
      if (cr.right > lr.right - 24) list.scrollLeft += cr.left - lr.left - 48;
    }
    update();
  }
  function run() { document.querySelectorAll('[data-tmc-scroller]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
